"use client";
import { jsx as n, jsxs as C } from "react/jsx-runtime";
import { Icon as i } from "../icon/icon.js";
import { useId as k, useRef as x, useState as l, useEffect as y } from "react";
import I from "clsx";
import { useScroll as L, useWindowSize as w } from "react-use";
import { useDraggable as W } from "react-use-draggable-scroll";
import { c as j, d as B } from "../../virginmediao2-momentum-icons-icons-far-BQVtGVjv.js";
import '../../assets/tabs.css';const o = {
  "tabs-container": "_tabs-container_1dhft_1",
  "tabs-container--breakout": "_tabs-container--breakout_1dhft_5",
  "tabs-container__head": "_tabs-container__head_1dhft_9",
  "tabs-container__controls": "_tabs-container__controls_1dhft_17",
  "tabs-container__navigation": "_tabs-container__navigation_1dhft_34",
  "tabs-container__navigation-control": "_tabs-container__navigation-control_1dhft_47",
  "tab-control": "_tab-control_1dhft_89"
}, G = ({
  children: _,
  breakout: f,
  controls: e,
  className: d
}) => {
  const a = k(), t = x(null), { events: b } = W(t, {
    isMounted: !!t
  }), [h, m] = l(!1), [u, v] = l(!1), { x: r } = L(t), { width: g } = w();
  y(() => {
    var s, c;
    const R = ((s = t.current) == null ? void 0 : s.scrollWidth) || 1 / 0, S = r + (((c = t.current) == null ? void 0 : c.offsetWidth) || 1 / 0);
    m(r > 30), v(S < R - 30);
  }, [r, t, g]);
  const p = () => {
    t.current && t.current.scrollBy({ left: -200, behavior: "smooth" });
  }, N = () => {
    t.current && t.current.scrollBy({ left: 200, behavior: "smooth" });
  };
  return /* @__PURE__ */ n(
    "div",
    {
      className: I(
        {
          [o["tabs-container"]]: !0,
          [o["tabs-container--breakout"]]: f
        },
        d
      ),
      children: /* @__PURE__ */ C("div", { className: o["tabs-container__head"], children: [
        e && /* @__PURE__ */ n("div", { className: o["tabs-container__navigation"], children: /* @__PURE__ */ n(
          "button",
          {
            className: o["tabs-container__navigation-control"],
            onClick: p,
            "aria-controls": a,
            disabled: !h,
            children: /* @__PURE__ */ n(i, { icon: j })
          }
        ) }),
        /* @__PURE__ */ n(
          "div",
          {
            id: a,
            ref: t,
            className: o["tabs-container__controls"],
            role: "tablist",
            ...b,
            children: _
          }
        ),
        e && /* @__PURE__ */ n("div", { className: o["tabs-container__navigation"], children: /* @__PURE__ */ n(
          "button",
          {
            className: o["tabs-container__navigation-control"],
            "aria-controls": a,
            onClick: N,
            disabled: !u,
            children: /* @__PURE__ */ n(i, { icon: B })
          }
        ) })
      ] })
    }
  );
};
export {
  G as Tabs
};
